// 供应链相关Api

import { App, defineAppApi } from '@zto/zpage'

export default defineAppApi((app: App) => {
  return {
    baseUrl: app.env.scmUrl,

    methods: api => {
      return {
        /** 获取token */
        async getToken(code: string) {
          const res: any = await api.fetch({
            url: 'zscm.base.iam.getToken',
            data: { code, clientSource: app.env.scmClientSource },
            headers: app.env.scmHeaders
          })

          return res
        },

        /** 刷新token */
        async exchangeToken(refreshToken: string) {
          const accessToken = app.token.getAccessToken()

          const res: any = await api.fetch({
            url: 'zscm.base.iam.refreshToken',
            data: { refreshToken, accessToken, clientSource: app.env.scmClientSource },
            headers: app.env.scmHeaders,
            isSilent: true
          })

          return res
        }
      }
    }
  }
})
